<template>
  <div>
    <v-row dense class="match-height">
      <v-col
        cols="3"
        sm="2"
        md="2"
        lg="2"
        v-for="(positionCounter, index) in positionCounters"
        :key="index"
        class="align-self-center"
      >
        <v-card
          outlined
          :color="$vuetify.theme.dark ? 'grey darken-2' : 'grey lighten-3'"
          max-height="100px"
          class="text-center d-flex justify-center align-center"
          :light="!$vuetify.theme.dark"
          :dark="$vuetify.theme.dark"
        >
          <v-card-text class="pa-0 px-0">
            <div>
              <div
                class="font-weight-medium"
                :class="[
                  $vuetify.breakpoint.smAndDown ? 'text-h6 mb-n2' : 'text-h5 ',
                ]"
              >
                {{ getPositionCount(positionCounter) }}
              </div>
              <div class="subtitle-2 font-weight-regular text--darken-4">
                {{ positionCounter.shortTitle }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "PositionCountersCard",
  props: {
    positionCounters: {
      type: Array,
      required: true,
      default: () => [],
    },
    availablePersonnel: {
      type: Array,
      required: true,
      default: () => [],
    },
    calculationMode: {
      type: String,
      required: false,
      default: "all", // possible values: "all", "
    },
  },
  data() {
    return {
      countedPersonsInHighestMode: new Set(), // Track persons already counted in "highest" mode
    };
  },
  methods: {
    getPositionCount(positionCounter) {
      const positionIds =
        positionCounter.positionIds || positionCounter.positions || [];
      const allowMultipleCounts = positionCounter.allowMultipleCounts || false;

      if (!positionIds || !Array.isArray(positionIds)) {
        console.warn("Invalid positionIds:", positionIds);
        return 0;
      }

      // Count available personnel (status id "1") who can fill any of the requested positions
      const availablePersonnel = this.availablePersonnel.filter(
        (person) => person.status.id === "1"
      );

      const includedPersons = []; // Track persons included in the count

      const count = availablePersonnel.reduce((total, person) => {
        const hasRequiredData =
          person.user && person.user?.fillablePositions?.ids;
        let canFillPosition = false;
        let fillablePositions = [];

        if (hasRequiredData) {
          // Ensure fillablePositions is an array
          fillablePositions = Array.isArray(person.user.fillablePositions.ids)
            ? person.user.fillablePositions.ids
            : [];

          // Check if person can fill any of the requested positions
          canFillPosition = fillablePositions.some((fillablePos) =>
            positionIds.includes(fillablePos)
          );

          if (canFillPosition) {
            // In "highest" mode, count each person only once across all position categories
            // UNLESS the counter has allowMultipleCounts enabled
            if (this.calculationMode === "highest" && !allowMultipleCounts) {
              if (this.countedPersonsInHighestMode.has(person.user.uid)) {
                // Person already counted in another position category
                return total;
              }
              // Mark this person as counted
              this.countedPersonsInHighestMode.add(person.user.uid);
            }
            // In "all" mode, OR if allowMultipleCounts is true, count person for each position category they can fill

            includedPersons.push(
              person.user?.displayName || person.user?.uid || "Unknown"
            );
          }
        }

        return canFillPosition ? total + 1 : total;
      }, 0);

      return count;
    },
  },
  watch: {
    // Reset the counted persons when calculation mode or available personnel changes
    calculationMode() {
      this.countedPersonsInHighestMode.clear();
    },
    availablePersonnel() {
      this.countedPersonsInHighestMode.clear();
    },
  },
};
</script>

<style scoped>
/* Add any specific styles for the position counters here */
</style>
